import {
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
  useMutation as useApolloMutation,
} from '@apollo/client';
import { DocumentNode } from 'apollo-link/lib/types';

import { useGraphQLErrorHandler } from '@sbu/hooks.graphqlerrorhandler';

type MutationOptions = {
  notifyErrors?: boolean;
};

export function useMutation<TData = any, TVariables = OperationVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables> & MutationOptions
): MutationTuple<TData, TVariables> {
  const [mutate, meta] = useApolloMutation<TData, TVariables>(mutation, {
    errorPolicy: 'all',
    ...(options || {}),
  });
  const loading = meta.loading;
  const error = meta.error;
  const { notifyErrors = true } = options || {};

  useGraphQLErrorHandler({ error, loading, notifyErrors });

  return [mutate, meta] as MutationTuple<TData, TVariables>;
}
